/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Step_SetupInputs */

const cs_import_step_setup = /** @type {(inputs: Import_Step_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavení`)
};

const en_import_step_setup = /** @type {(inputs: Import_Step_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setup`)
};

/**
* | output |
* | --- |
* | "Setup" |
*
* @param {Import_Step_SetupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_step_setup = /** @type {((inputs?: Import_Step_SetupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Step_SetupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_step_setup(inputs)
	return cs_import_step_setup(inputs)
});